import axios, {AxiosResponse}  from 'axios'
import {AuthModel, UserModel,UserAccess} from './_models'

const API_URL = process.env.REACT_APP_API_URL
// const API_URL = 'http://156.67.208.29:5000/api'



export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}user/verify-token`
export const LOGIN_URL = `${API_URL}user/login`
export const REGISTER_URL = `${API_URL}user/create-user`
export const REQUEST_PASSWORD_URL = `${API_URL}user/forgot-password`
export const REQUEST_ACCESS = `${API_URL}user/get-current-user-access`

// Server should return AuthModel
export function login(login_id: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    login_id,
    password,
  })
}

export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}


export function getUserAccess() {
  return axios.get<UserAccess>(REQUEST_ACCESS)
}